export default function () {
  let _selection;

  function chart(selection) {
    selection.each(function (data) {      
      _selection = selection;

      _selection.style('position', 'absolute')
        .style('pointer-events', 'none')
        .style('z-index', 1050)
        .style('background', 'white')
        .style('padding', '6px')
        .style('border', '1px solid black')
        .style('border-radius', '4px')
        .style('box-shadow', '2px 2px 4px rgba(0, 0, 0, 0.4)');

      _selection.append('p')
        .style('font-weight', 'bold')
        .style('font-size', '12px');

      _selection.append('div').append('ul')
        .style('list-style-type', 'none')
        .style('padding', '0px')
        .style('margin', '0px')
        .style('font-size', '12px');

      chart.hide();
    });
  }

  function updatePosition(position) {
    const offset = 10;
    _selection.style('left', position.x + offset + 'px')
      .style('top', position.y + offset + 'px');
  }

  function updateContent(data, title) {
    _selection.select('p')
      .html(title);

    if (data.length === 0) {
      return;
    }

    const items = _selection.select('ul')
      .selectAll('li')
      .data(data);

    const itemsEnter = items.enter().append('li');

    itemsEnter.append('span')
      .attr('class', 'tooltip--key');

    itemsEnter.append('span')
      .attr('class', 'tooltip--value')
      .style('text-align', 'right')
      .style('float', 'right')
      .style('padding-left', '10px');

    items.select('.tooltip--key')
      .text(function (d) { return d.key; });

    items.select('.tooltip--value')
      .text(function (d) { return d.value !== null ? d.value : ''; });
  }

  chart.show = function () {
    _selection.style('display', 'block');
    return chart;
  }

  chart.update = function (position, data, title) {
    updatePosition(position);
    updateContent(data, title);

    return chart;
  }

  chart.hide = function () {
    _selection.style('display', 'none');
    return chart;
  }

  return chart;
}



// WEBPACK FOOTER //
// ./src/charts/d3/d3-tooltip.js